import { useState } from "react";
import { ArrowUpRight, Download, FileText } from "lucide-react";
import { toast } from "sonner";
import { PROFILE } from "@/data/portfolio";
import { downloadResume } from "@/utils/download";

export default function ResumeWindow() {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className="flex h-full flex-col gap-3 p-5" data-testid="resume-content">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-rose-500/15 ring-1 ring-rose-500/25">
            <FileText size={16} className="text-rose-300" />
          </span>
          <div>
            <p className="font-mono text-xs font-medium text-slate-100">{PROFILE.resumeFile}</p>
            <p className="font-mono text-[10px] text-slate-500">PDF · 114 KB · latest version</p>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => {
              downloadResume();
              toast("Resume downloading — AnishResume_WA.pdf");
            }}
            data-testid="resume-download-btn"
            className="flex items-center gap-1.5 rounded-lg bg-sonoma px-3 py-2 font-mono text-[11px] text-white transition-colors duration-150 hover:bg-[#0062CC]"
          >
            <Download size={12} /> download
          </button>
          <a
            href={PROFILE.resume}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="resume-open-tab"
            className="flex items-center gap-1.5 rounded-lg border border-white/12 bg-white/5 px-3 py-2 font-mono text-[11px] text-slate-200 transition-colors duration-150 hover:bg-white/10"
          >
            <ArrowUpRight size={12} /> new tab
          </a>
        </div>
      </div>

      <div className="relative min-h-0 flex-1 overflow-hidden rounded-lg border border-white/10 bg-white/5">
        {!loaded && (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2" data-testid="resume-loading">
            <div className="skeleton h-4 w-40 rounded" />
            <p className="font-mono text-[11px] text-slate-500">loading preview…</p>
          </div>
        )}
        <iframe
          src={`${PROFILE.resume}#view=FitH`}
          title="Anish Ravi — Resume PDF"
          onLoad={() => setLoaded(true)}
          data-testid="resume-preview"
          className="h-full w-full bg-white"
        />
      </div>
    </div>
  );
}
